<app-welcome-setup-modal></app-welcome-setup-modal>
<div class="dashboard-v2-page">
    <div class="dashboard-v2-content">
        <!-- TODO re-enable: setup guide card hidden per request -->
        <ng-container *ngIf="false && !isSetupGuideHiddenForUser">
            <ng-container *ngIf="isSetupLoading; else setupGuideContent">
                <section class="setup-guide-card setup-guide-card-skeleton">
                    <div class="setup-guide-header">
                        <div class="setup-title-group">
                            <p-skeleton
                                width="16rem"
                                height="1rem"
                                styleClass="mb-2"
                            ></p-skeleton>
                            <p-skeleton
                                width="14rem"
                                height="0.95rem"
                            ></p-skeleton>
                        </div>
                        <div class="setup-progress-wrap">
                            <p-skeleton
                                width="2.8rem"
                                height="1rem"
                            ></p-skeleton>
                            <p-skeleton
                                width="1rem"
                                height="1rem"
                                borderRadius="50%"
                            ></p-skeleton>
                        </div>
                    </div>
                    <div class="setup-progress-bar setup-progress-bar-skeleton">
                        <p-skeleton width="100%" height="4px"></p-skeleton>
                    </div>
                    <div class="setup-guide-body-skeleton">
                        <div
                            class="setup-step-row setup-step-row-skeleton"
                            *ngFor="let _ of tableSkeletonRows"
                        >
                            <div class="setup-step-left">
                                <p-skeleton
                                    width="1rem"
                                    height="1rem"
                                    borderRadius="50%"
                                ></p-skeleton>
                                <p-skeleton
                                    width="11rem"
                                    height="0.95rem"
                                ></p-skeleton>
                            </div>
                            <p-skeleton
                                width="0.9rem"
                                height="0.9rem"
                                borderRadius="50%"
                            ></p-skeleton>
                        </div>
                    </div>
                </section>
            </ng-container>
        </ng-container>

        <ng-template #setupGuideContent>
            <section
                class="setup-guide-card"
                *ngIf="isStoreContentUiReady && sellsOnline"
            >
                <div class="setup-guide-header" (click)="toggleSetupCard()">
                    <div class="setup-title-group">
                        <div class="setup-title">
                            Your online store is in progress...
                        </div>
                        <div class="setup-subtitle">
                            Complete these steps to setup your business
                        </div>
                    </div>
                    <div class="setup-progress-wrap">
                        <div class="setup-progress-text">
                            {{ setupCompletedCount }}/{{ setupTotalCount }}
                        </div>
                        <i
                            class="pi"
                            [ngClass]="
                                isSetupOpen
                                    ? 'pi-chevron-up'
                                    : 'pi-chevron-down'
                            "
                        ></i>
                    </div>
                </div>

                <div class="setup-progress-bar">
                    <span [style.width.%]="setupProgressPercent"></span>
                </div>

                <div class="setup-guide-body" *ngIf="isSetupOpen">
                    <ng-container *ngFor="let step of setupSteps">
                        <div
                            class="setup-step-row"
                            [class.setup-step-row-expandable]="
                                isSetupStepExpandable(step)
                            "
                            (click)="toggleSetupStep(step)"
                        >
                            <div class="setup-step-left">
                                <i
                                    class="pi step-icon"
                                    [ngClass]="
                                        step.completed
                                            ? 'pi-check-circle step-complete'
                                            : 'pi-times-circle step-pending'
                                    "
                                ></i>
                                <span>{{ step.label }}</span>
                            </div>
                            <i
                                class="pi"
                                [ngClass]="
                                    step.expanded
                                        ? 'pi-chevron-up'
                                        : 'pi-chevron-left'
                                "
                            ></i>
                        </div>

                        <div
                            class="setup-step-detail-area"
                            *ngIf="!isStoreContentStep(step) && step.expanded"
                        >
                            <p class="setup-step-detail-text">
                                {{ getStepDescription(step) }}
                            </p>
                            <button
                                type="button"
                                class="setup-step-action-btn"
                                *ngIf="shouldShowStepAction(step)"
                                (click)="onStepAction(step, $event)"
                            >
                                {{ getStepActionLabel(step) }}
                            </button>
                        </div>

                        <div
                            class="setup-store-content-area"
                            *ngIf="isStoreContentStep(step) && step.expanded"
                        >
                            <p class="store-content-current-status">
                                Current Status:
                                <strong>{{
                                    currentStoreContentStatusText
                                }}</strong>
                            </p>
                            <p
                                class="store-content-upload-status store-content-upload-status-info"
                                *ngIf="isStoreContentInProgress"
                            >
                                Your store content file has been uploaded
                                successfully and is currently in progress.
                            </p>
                            <p
                                *ngIf="
                                    !isStoreContentInProgress &&
                                    canUploadStoreContent
                                "
                            >
                                Please upload the filled store content file.
                                (Maximum file size: 25 MB)
                            </p>
                            <div
                                class="setup-actions"
                                *ngIf="!isStoreContentInProgress"
                            >
                                <label
                                    class="btn-upload"
                                    [class.btn-upload-disabled]="
                                        !canUploadStoreContent
                                    "
                                    *ngIf="canUploadStoreContent"
                                >
                                    {{
                                        isStoreContentUploading
                                            ? "Uploading..."
                                            : "Upload File"
                                    }}
                                    <input
                                        type="file"
                                        accept=".doc,.docx"
                                        [disabled]="!canUploadStoreContent"
                                        (change)="onStoreContentUpload($event)"
                                    />
                                </label>
                                <button
                                    type="button"
                                    class="btn-download"
                                    *ngIf="canUploadStoreContent"
                                    (click)="downloadStoreContentTemplate()"
                                >
                                    Download File
                                </button>
                            </div>

                            <p
                                class="store-content-upload-status store-content-upload-status-info"
                                *ngIf="
                                    !isStoreContentInProgress &&
                                    !canUploadStoreContent &&
                                    storeContentUploadDisabledReason
                                "
                            >
                                {{ storeContentUploadDisabledReason }}
                            </p>

                            <div
                                class="store-content-upload-progress"
                                *ngIf="isStoreContentUploading"
                            >
                                <div class="store-content-upload-progress-head">
                                    <span>{{
                                        storeContentUploadStatusText ||
                                            "Uploading..."
                                    }}</span>
                                    <span
                                        >{{ storeContentUploadProgress }}%</span
                                    >
                                </div>
                                <div
                                    class="store-content-upload-progress-track"
                                >
                                    <span
                                        [style.width.%]="
                                            storeContentUploadProgress
                                        "
                                    ></span>
                                </div>
                            </div>

                            <p
                                class="store-content-upload-status store-content-upload-status-success"
                                *ngIf="
                                    !isStoreContentUploading &&
                                    storeContentUploadStatusText &&
                                    !storeContentUploadError &&
                                    !isStoreContentInProgress
                                "
                            >
                                {{ storeContentUploadStatusText }}
                            </p>
                            <p
                                class="store-content-upload-status store-content-upload-status-error"
                                *ngIf="storeContentUploadError"
                            >
                                {{ storeContentUploadError }}
                            </p>
                        </div>
                    </ng-container>
                </div>
            </section>
        </ng-template>

        <div class="summary-filter-row">
            <p-button
                class="p-button-sm"
                (onClick)="summaryRangeOp.toggle($event)"
                icon="pi pi-filter"
                [label]="selectedSummaryRange"
                iconPos="right"
            ></p-button>
        </div>
        <p-overlayPanel
            #summaryRangeOp
            styleClass="summary-range-op"
            appendTo="body"
            (onShow)="onSummaryRangeOverlayShow()"
        >
            <p-menu
                [model]="summaryRangeItems"
                (click)="summaryRangeOp.hide()"
                [style]="{ 'min-width': '180px', border: '0px' }"
            ></p-menu>
        </p-overlayPanel>

    <section class="summary-cards-grid">
      <ng-container *ngIf="!isSummaryLoading; else summaryCardsSkeleton">
        <article class="summary-card" *ngFor="let card of summaryCards" [class.summary-card-highlight]="card.highlighted">
          <div class="summary-card-head">
            <span>{{ card.title }}</span>
            <i
              class="pi pi-arrow-up-right summary-drilldown-icon"
              *ngIf="shouldShowSummaryDrillDownIcon"
              (click)="goToDailySalesReport()"
            ></i>
          </div>
          <div class="summary-card-value-row">
            <div class="summary-card-value">{{ card.value | currencySpacing }}</div>
            <span
              class="trend"
              *ngIf="card.hasTrend"
              [class.trend-positive]="card.positiveTrend"
              [class.trend-negative]="!card.positiveTrend"
            >
              <i class="pi" [ngClass]="card.positiveTrend ? 'pi-arrow-up' : 'pi-arrow-down'"></i>
              {{ card.trend }}
            </span>
          </div>
          <div class="summary-breakdown">
            <div *ngIf="showInStoreBreakdown"><span class="dot"></span>In-Store {{ card.inStore | currencySpacing }}</div>
            <div *ngIf="showOnlineBreakdown"><span class="dot"></span>Online {{ card.online | currencySpacing }}</div>
          </div>
        </article>
      </ng-container>
      <ng-template #summaryCardsSkeleton>
        <article class="summary-card" *ngFor="let _ of summarySkeletonCards">
          <p-skeleton width="7rem" height="1rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="9rem" height="2rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="4rem" height="1.2rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="90%" height="0.85rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="70%" height="0.85rem"></p-skeleton>
        </article>
      </ng-template>
    </section>

        <section class="product-grid">
            <ng-container *ngIf="!isTablesLoading; else productTablesSkeleton">
                <article class="table-card">
                    <h3>Best Selling Products</h3>
                    <p-table
                        [autoLayout]="true"
                        [tableStyle]="{ width: '100%' }"
                        [value]="bestSellingProducts"
                        styleClass="p-datatable-striped"
                        [paginator]="bestSellingProducts.length > 5"
                        [rows]="5"
                        responsiveLayout="scroll"
                        showLoader="true"
                        rowHover="true"
                    >
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 70px; min-width: 70px"></th>
                                <th>NAME</th>
                                <th style="text-align: right">QTY SOLD</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr>
                                <td style="width: 70px; min-width: 70px">
                                    <img
                                        [src]="
                                            product.image || defaultProductImage
                                        "
                                        [alt]="product.name"
                                        class="product-table-thumb"
                                        (error)="onProductImageError($event)"
                                    />
                                </td>
                                <td>
                                    <div class="product-name">
                                        {{ product.name }}
                                    </div>
                                </td>
                                <td style="text-align: right; font-weight: 700">
                                    {{ product.qty }}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="3" class="table-empty">
                                    No data found
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </article>

                <article class="table-card">
                    <h3>
                        Low Stock Products
                        <span class="threshold-tag"
                            >(Qty ≤ {{ lowStockThreshold }})</span
                        >
                    </h3>
                    <p-table
                        [autoLayout]="true"
                        [tableStyle]="{ width: '100%' }"
                        [value]="lowStockProducts"
                        styleClass="p-datatable-striped"
                        [paginator]="lowStockProducts.length > 5"
                        [rows]="5"
                        responsiveLayout="scroll"
                        showLoader="true"
                        rowHover="true"
                    >
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 70px; min-width: 70px"></th>
                                <th>Product Name</th>
                                <th style="text-align: right">Qty in Hand</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr>
                                <td style="width: 70px; min-width: 70px">
                                    <img
                                        [src]="
                                            product.image || defaultProductImage
                                        "
                                        [alt]="product.name"
                                        class="product-table-thumb"
                                        (error)="onProductImageError($event)"
                                    />
                                </td>
                                <td>
                                    <div class="product-name">
                                        {{ product.name }}
                                    </div>
                                </td>
                                <td style="text-align: right">
                                    <span
                                        [class]="
                                            getBadgeClass(product.badgeType)
                                        "
                                        >{{ product.badge }}</span
                                    >
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="3" class="table-empty">
                                    No data found
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </article>
            </ng-container>
            <ng-template #productTablesSkeleton>
                <article class="table-card">
                    <h3>Best Selling Products</h3>
                    <div class="table-skeleton-head"></div>
                    <div
                        class="table-skeleton-row"
                        *ngFor="let _ of tableSkeletonRows"
                    >
                        <p-skeleton shape="circle" size="2.6rem"></p-skeleton>
                        <div class="table-skeleton-text">
                            <p-skeleton width="90%" height="1rem"></p-skeleton>
                        </div>
                        <p-skeleton width="3.5rem" height="1rem"></p-skeleton>
                    </div>
                </article>
                <article class="table-card">
                    <h3>
                        Low Stock Products
                        <span class="threshold-tag"
                            >(Qty ≤ {{ lowStockThreshold }})</span
                        >
                    </h3>
                    <div class="table-skeleton-head"></div>
                    <div
                        class="table-skeleton-row"
                        *ngFor="let _ of tableSkeletonRows"
                    >
                        <p-skeleton shape="circle" size="2.6rem"></p-skeleton>
                        <div class="table-skeleton-text">
                            <p-skeleton width="90%" height="1rem"></p-skeleton>
                        </div>
                        <p-skeleton
                            width="6.5rem"
                            height="1.2rem"
                            borderRadius="12px"
                        ></p-skeleton>
                    </div>
                </article>
            </ng-template>
        </section>

        <section class="sales-bottom-grid">
            <article class="chart-card">
                <ng-container *ngIf="!isSalesLoading; else salesWidgetSkeleton">
                    <div class="chart-head">
                        <div>
                            <div class="chart-value">
                                {{ averageDailySale | currencySpacing }}
                            </div>
                            <div class="chart-caption">Average Sale</div>
                        </div>
                        <p-dropdown
                            [options]="filterOptions"
                            optionLabel="label"
                            optionValue="value"
                            [(ngModel)]="selectedSalesRange"
                            (onChange)="onSalesRangeChange()"
                            styleClass="dashboard-filter-dropdown"
                            [showClear]="false"
                            appendTo="body"
                        ></p-dropdown>
                    </div>

                    <div class="legend">
                        <span
                            ><i class="legend-box blue"></i>Net Sales ({{
                                "" | currency | currencySymbol
                            }})</span
                        >
                        <span
                            ><i class="legend-box orange"></i>Credit Card ({{
                                "" | currency | currencySymbol
                            }})</span
                        >
                        <span
                            ><i class="legend-box yellow"></i>Cash ({{
                                "" | currency | currencySymbol
                            }})</span
                        >
                    </div>

                    <div class="chart-plot">
                        <div class="y-axis">
                            <span
                                class="y-tick"
                                *ngFor="let tick of chartYAxisTicks"
                                >{{ formatAxisTick(tick) }}</span
                            >
                        </div>

                        <div class="bar-chart-wrap">
                            <div
                                class="bar-chart"
                                [style.gridTemplateColumns]="
                                    chartGridTemplateColumns
                                "
                            >
                                <div
                                    class="chart-day"
                                    *ngFor="let point of salesSeries"
                                >
                                    <div class="bars">
                                        <span
                                            class="bar bar-blue"
                                            *ngIf="point.netSales > 0"
                                            [style.height.%]="
                                                getBarHeight(point.netSales)
                                            "
                                            [attr.title]="
                                                point.label +
                                                ' | Net Sales: ' +
                                                (point.netSales
                                                    | currencyDisplay)
                                            "
                                        ></span>
                                        <span
                                            class="bar bar-orange"
                                            *ngIf="point.creditCard > 0"
                                            [style.height.%]="
                                                getBarHeight(point.creditCard)
                                            "
                                            [attr.title]="
                                                point.label +
                                                ' | Credit Card: ' +
                                                (point.creditCard
                                                    | currencyDisplay)
                                            "
                                        ></span>
                                        <span
                                            class="bar bar-yellow"
                                            *ngIf="point.cash > 0"
                                            [style.height.%]="
                                                getBarHeight(point.cash)
                                            "
                                            [attr.title]="
                                                point.label +
                                                ' | Cash: ' +
                                                (point.cash | currencyDisplay)
                                            "
                                        ></span>
                                    </div>
                                    <div class="day-label">
                                        {{ point.label }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #salesWidgetSkeleton>
                    <div class="chart-head">
                        <div>
                            <p-skeleton
                                width="8rem"
                                height="3rem"
                                styleClass="mb-2"
                            ></p-skeleton>
                            <p-skeleton width="9rem" height="1rem"></p-skeleton>
                        </div>
                        <p-skeleton
                            width="7.6rem"
                            height="2.3rem"
                            borderRadius="10px"
                        ></p-skeleton>
                    </div>
                    <div class="legend">
                        <p-skeleton width="5.8rem" height="0.9rem"></p-skeleton>
                        <p-skeleton width="6.6rem" height="0.9rem"></p-skeleton>
                        <p-skeleton width="4.8rem" height="0.9rem"></p-skeleton>
                    </div>
                    <p-skeleton
                        width="100%"
                        height="220px"
                        borderRadius="10px"
                    ></p-skeleton>
                </ng-template>
            </article>

            <article class="top-product-card">
                <ng-container
                    *ngIf="!isTopProductLoading; else topProductWidgetSkeleton"
                >
                    <div class="top-product-head">
                        <span class="top-product-title">Top Product</span>
                        <p-dropdown
                            [options]="topProductFilterOptions"
                            optionLabel="label"
                            optionValue="value"
                            [(ngModel)]="selectedTopProductRange"
                            (onChange)="onTopProductRangeChange()"
                            styleClass="dashboard-filter-dropdown"
                            [showClear]="false"
                            appendTo="body"
                        ></p-dropdown>
                    </div>
                    <div class="top-product-body">
                        <div class="top-product-image-wrap">
                            <img
                                [src]="topProduct.image || defaultProductImage"
                                [alt]="topProduct.name"
                                (error)="onProductImageError($event)"
                            />
                        </div>
                        <div class="top-product-name" *ngIf="topProduct.name">
                            {{ topProduct.name }}
                        </div>
                        <div class="top-product-qty">
                            <strong>{{ topProduct.quantitySold }}</strong>
                            Quantity sold
                        </div>
                    </div>
                </ng-container>
                <ng-template #topProductWidgetSkeleton>
                    <div class="top-product-head">
                        <p-skeleton width="8rem" height="2rem"></p-skeleton>
                        <p-skeleton
                            width="7.6rem"
                            height="2.3rem"
                            borderRadius="10px"
                        ></p-skeleton>
                    </div>
                    <div class="top-product-body">
                        <div class="top-product-skeleton-image">
                            <p-skeleton
                                shape="circle"
                                size="132px"
                            ></p-skeleton>
                        </div>
                        <div class="top-product-skeleton-text">
                            <p-skeleton
                                width="5rem"
                                height="1.5rem"
                                styleClass="mb-2"
                            ></p-skeleton>
                            <p-skeleton width="7rem" height="1rem"></p-skeleton>
                        </div>
                    </div>
                </ng-template>
            </article>
        </section>
    </div>
</div>
